import React from "react";

import NotificationList from "components/Notification/NotificationList";

export default function NotificationPage() {
  return <NotificationList />;
}
